import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import EditIcon from "@mui/icons-material/Edit";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import DeletePop from "../../constants/ErrorPermissionModal";
const ActionMobileDrop = ({
  title,
  handleDelete,
  active,
  setActive,
  sub,
  index,
  handleup,
  handledown,
  handleEdit,
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <div
          onClick={() => setActive(!active)}
          style={{
            border: "2px solid black",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "30px",
            width: "30px",
            borderRadius: "1000px",
            cursor: "pointer",
          }}
        >
          {active ? <ArrowDropUpIcon></ArrowDropUpIcon> : <ArrowDropDownIcon />}
        </div>{" "}
        <div
          style={{
            display: "flex",
            fontWeight: "bold",
          }}
        >
          <div
            className="datatite"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {String(title || "Menu Title")}
          </div>
        </div>{" "}
      </div>{" "}
      <div
        style={{
          display: "flex",
          fontWeight: "bold",
        }}
      >
        {handleup && (
          <div
            style={{
              display: "flex",
              alignItems: "center",

              marginRight: "10px",
            }}
          >
            <div
              style={{
                cursor: "pointer",
                color: "#9f9f9f",
                marginLeft: "20px",
              }}
              onClick={() => handleup(index)}
            >
              <ArrowCircleUpIcon style={{ color: "red", fontSize: 28 }} />
            </div>
            <div
              style={{
                cursor: "pointer",
                color: "#9f9f9f",
                marginRight: "20px",
              }}
              onClick={() => handledown(index)}
            >
              <ArrowCircleDownIcon style={{ color: "green", fontSize: 28 }} />
            </div>
          </div>
        )}
        {sub && (
          <div style={{ cursor: "pointer" }} onClick={handleEdit}>
            <EditIcon />
          </div>
        )}
        {title !== "Display Purchase Price" && (
          <div style={{ cursor: "pointer", color: "#9f9f9f" }}>
            <DeletePop onConfirm={handleDelete}>
              {" "}
              <DeleteIcon style={{ color: "#9f9f9f" }} />
            </DeletePop>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActionMobileDrop;
